'use client';

import React, { useEffect, useState, useContext } from 'react';
import Footer from '../../../components/footer/Footer';
import Navbar from '../../../components/Navbar';
import { UserContext } from '@/context/UserContext';

import TeacherHeroSection from './components/TeacherHeroSection';
// import TeacherStatsSection from './components/TeacherStatsSection';
import TeacherAboutSection from './components/TeacherAboutSection';
import TeacherUpcomingClasses from './components/TeacherUpcomingClasses';
import TeacherCoursesOffered from './components/TeacherCoursesOffered';
import TeacherReviewsSection from './components/TeacherReviewsSection';
import MessageTeacherModal from './components/MessageTeacherModal';

export default function TeacherProfilePageClientNew({
  profileData,
  baseUrl,
  upcomingCourses,
}) {
  const ctx = useContext(UserContext);

  const currentUserId =
    ctx?.id || ctx?.user?.id || ctx?.data?.id || ctx?.session?.user?.id || null;

  const [showBackToTop, setShowBackToTop] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  // Stop the "blue initials screen" glitch by rendering a stable loading state
  if (!profileData) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <div className="max-w-5xl mx-auto px-4 py-24 text-center text-gray-600">
          Loading teacher profile...
        </div>
        <Footer />
      </div>
    );
  }

  const isOwnProfile = Boolean(currentUserId && profileData?.id === currentUserId);

  const updatedProfileData = {
    ...profileData,
    isOwnProfile,
  };

  // Back-to-top scroll logic
  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const openMessageModal = () => setIsMessageModalOpen(true);
  const closeMessageModal = () => setIsMessageModalOpen(false);

  const handleEnrollClick = () => {
    const el = document.getElementById('upcoming-classes');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {showBackToTop && (
        <button
          id="back-to-top"
          className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-colors z-40"
          aria-label="Back to Top"
          onClick={scrollToTop}
        >
          ↑
        </button>
      )}

      <TeacherHeroSection
        profileData={updatedProfileData}
        onMessageClick={openMessageModal}
        onEnrollClick={handleEnrollClick}
      />

      {/* <TeacherStatsSection profileData={updatedProfileData} /> */}

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-8">
            <TeacherAboutSection profileData={updatedProfileData} />

            <div id="upcoming-classes">
              <TeacherUpcomingClasses upcomingCourses={upcomingCourses || []} />
            </div>

            <TeacherCoursesOffered
              profileData={updatedProfileData}
              baseUrl={baseUrl}
            />
          </div>

          <div className="space-y-8">
            <div id="reviews">
              <TeacherReviewsSection profileData={updatedProfileData} />
            </div>
          </div>
        </div>
      </main>

      <MessageTeacherModal
        isOpen={isMessageModalOpen}
        onClose={closeMessageModal}
        teacherId={updatedProfileData?.id}
        teacherName={updatedProfileData?.name}
        currentUserId={currentUserId}
      />

      <Footer />
    </div>
  );
}